import addDate from './addDate';
import getFirstAvailableDate from './getFirstAvailableDate';

export default function getCalendarRanges (maxDaysSearch, firstAvailableDate) {
  const today = new Date();
  const maxDate = addDate(new Date(), maxDaysSearch);
  // If a first available date is given, the days before it are blocked
  const minDate = getFirstAvailableDate(firstAvailableDate, maxDaysSearch) || today;
  const min = [minDate.getFullYear(), minDate.getMonth(), minDate.getDate()];
  const max = [maxDate.getFullYear(), maxDate.getMonth(), maxDate.getDate()];
  return { min, max };
}
